<template>
	<div id="site-footer" class="flex-shrink-0 mt-auto">
		<div class="container px-4 py-5 text-center text-black">
			<div class="text-xs">
				Website maintained by <a href="https://www.activamedia.com.sg/" class="hover:underline">Activa Media</a>. <br class="xs:hidden">All Rights Reserved.
			</div>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#site-footer {
	background-color: white;
}
</style>
